/**
 * Fixture sets available to demo generation. Each value must match a directory
 * under `backend/src/modules/demoAccount/fixtures/`.
 */
export const DEMO_FIXTURE_ENVIRONMENTS = [
    "default",
    "dev",
    "sales",
    "luke",
] as const;

export type DemoFixtureEnvironment = (typeof DEMO_FIXTURE_ENVIRONMENTS)[number];

export const DEFAULT_DEMO_FIXTURE_ENVIRONMENT: DemoFixtureEnvironment =
    "default";

/**
 * Fixture sets a demo user can be seeded from. Superset of
 * `DEMO_FIXTURE_ENVIRONMENTS`: `firm` seeds a whole firm portfolio, so it only
 * applies to demo users, not to organization demo workspaces.
 */
export const DEMO_USER_SEED_FIXTURES = [
    ...DEMO_FIXTURE_ENVIRONMENTS,
    "firm",
] as const;

export type DemoUserSeedFixture = (typeof DEMO_USER_SEED_FIXTURES)[number];

export const DEFAULT_DEMO_USER_SEED_FIXTURE: DemoUserSeedFixture = "default";

export const isDemoUserSeedFixture = (
    value: string,
): value is DemoUserSeedFixture =>
    DEMO_USER_SEED_FIXTURES.some((fixture) => fixture === value);

export const DEFAULT_DEMO_CLIENT_NAME = "Demo client";
